import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";

export const QUERY_KEY = "getSubtitles";

export const useGetSubtitles = (url: string | null) => {
  return useQuery({
    queryKey: [QUERY_KEY, url],
    queryFn: async (): Promise<string> => {
      const response = await apiClient.get<string>(API_ROUTES.subtitles, {
        params: { url },
        responseType: "text",
      });
      return response.data;
    },
    enabled: !!url,
  });
};
